import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LoadingBuffer } from '../loading-buffer';
import { navigationSelector } from 'common/selectors/navigation';
import { navigationBuildAction } from 'common/actions/navigation';
import { urlChannelIdSelector } from 'pages/channel.page/selectors';
import { websiteSelector } from 'common/selectors';
import { withRouter } from 'react-router-dom';

const hasNavigationLoaded = (props) => props.navigation.length > 0;

class NavigationLoader extends React.Component {
  componentDidMount() {
    // When switching between different routes
    this.props.dispatch(navigationBuildAction(this.props.currentChannelId));
  }

  componentDidUpdate(prevProps) {
    if (this.props.website.isLoading !== prevProps.website.isLoading && !this.props.website.isLoading) {
      this.props.dispatch(navigationBuildAction(this.props.currentChannelId));
    }

    if (this.props.currentChannelId !== prevProps.currentChannelId) {
      // When switching same route with different params
      this.props.dispatch(navigationBuildAction(this.props.currentChannelId));
    }
  }

  render() {
    const newProps = { ...this.props, statusCallback: hasNavigationLoaded };
    return <LoadingBuffer {...newProps} />;
  }
}

const mapStateToProps = (state, props) => {
  const params = props.match && props.match.params;
  return {
    navigation: navigationSelector(state),
    currentChannelId: urlChannelIdSelector(params)(state),
    website: websiteSelector(state),
  };
};

export const NavigationLoaderDecorated = compose(withRouter, connect(mapStateToProps))(NavigationLoader);
